import {useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {useOverlayContext} from "../../contexts/OverlayContext";
import {useTheCellMapContext} from "../../contexts/TheCellMapContext";
import {usePostRiskCustom, usePostRiskScreen, usePostSafeCustom, usePostSafeScreen} from "../../hooks/useJsonLoader";
import {AlertType, OverlayDataType, OverlayType} from "../../types/enums";
import {OverlayResults} from "../../types/overlay";
import {isOverlayFormDataValid} from "../../utils/overlay";
import {useTrackOverlay} from "../../utils/tracker";

const OverlayModal = () => {
  const {addAlert} = useTheCellMapContext();
  const {
    setOverlayResults,
    showModal,
    overlayResults,
    customOverlayLists,
    overlayType,
    processOverlay,
    overlayScreen
  } = useOverlayContext();

  const trackOverlay = useTrackOverlay();

  const postSafeCustom = usePostSafeCustom();
  const postRiskCustom = usePostRiskCustom();

  const postSafeScreen = usePostSafeScreen();
  const postRiskScreen = usePostRiskScreen();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (overlayScreen) {
      let postScreen: (data: unknown, globalLoading?: boolean) => Promise<OverlayResults | undefined>;

      switch (overlayType) {
        case OverlayType.SAFE:
          postScreen = postSafeScreen;
          break
        case OverlayType.RISK:
          postScreen = postRiskScreen;
          break
      }

      trackOverlay(overlayType, overlayScreen);

      postScreen({
        screen: overlayScreen
      }).then(results => {
        setOverlayResults(results);
      });
    } else if (isOverlayFormDataValid(customOverlayLists)) {
      let postCustom: (data: unknown, globalLoading?: boolean) => Promise<OverlayResults | undefined>;

      switch (overlayType) {
        case OverlayType.SAFE:
          postCustom = postSafeCustom;
          break
        case OverlayType.RISK:
          postCustom = postRiskCustom;
          break
      }

      trackOverlay(overlayType, OverlayDataType.CUSTOM);

      postCustom({
        data: customOverlayLists
      }).then(results => {
        setOverlayResults(results);

        /* Remove screen query from URL if present, it's overriden by the custom list request */
        searchParams.delete("s");
        setSearchParams(searchParams);
      });
    }
  }, [processOverlay]);

  useEffect(() => {
    if (!overlayResults) return;

    if (Object.keys(overlayResults.enrichment.enriched_domains).length === 0) {
      addAlert({
        type: AlertType.Warning,
        message: "No enriched regions found for this overlay.",
        delay: 5000
      });

      showModal();
    }
  }, [overlayResults])

  return null;
}

export default OverlayModal;